import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ListingQuality = ({ contentDetails }) => {
  const { t } = useTranslation(["merchandising"]);
  return (
    <>
      <div className="fs-4 pb-2" style={{ fontWeight: "bold  " }}>
        {t(($) => $.merchandising["Listing Quality Details"])}
      </div>

      <Row className="fs-4">
        <Col xs={12} className="pb-2">
          <i
            className={`fa ${
              contentDetails.title_info.title_length === 100 ? "fa-check-circle text-success" : "fa-circle text-danger"
            } me-2`}
          ></i>
          {t(($) => $.merchandising["Title between 60 and 120 chars"])}
        </Col>
        <Col xs={12} className="pb-2">
          <i
            className={`fa ${
              contentDetails.title_info.special_chars === 100 ? "fa-check-circle text-success" : "fa-circle text-danger"
            } me-2`}
          ></i>
          {t(($) => $.merchandising["No Special Characters"])}
        </Col>
        <Col xs={12} className="pb-2">
          <i
            className={`fa ${
              contentDetails.bullet_info.bullet_count >= 100 ? "fa-check-circle text-success" : "fa-circle text-danger"
            } me-2`}
          ></i>
          {t(($) => $.merchandising["5 or more bullets"])}
        </Col>
        <Col xs={12} className="pb-2">
          <i
            className={`fa ${
              contentDetails.bullet_info.bullet_length >= 100 ? "fa-check-circle text-success" : "fa-circle text-danger"
            } me-2`}
          ></i>
          {t(($) => $.merchandising["Bullet between 150 and 250 chars"])}
        </Col>
        <Col xs={12} className="pb-2">
          <i
            className={`fa  ${
              contentDetails.image_score === 100 ? "fa-check-circle text-success" : "fa-circle text-danger"
            } me-2`}
          ></i>
          {t(($) => $.merchandising["6 or more images"])}
        </Col>
      </Row>
    </>
  );
};

export default ListingQuality;
